export const services = [
  {
    id: 'consulting',
    tag: '服务一',
    title: '营销数字化战略&咨询',
    subtitle: '数字化创新赋能企业显著提升业务价值',
    description: '由拥有近20年信息化和数字化从业经验的专家团队，深度诊断企业营销管理痛点，输出可落地的数字化转型路径规划。',
    items: ['营销现状诊断', 'bC营销策略设计（TP渠道激励+CP消费者激活）', '系统选型建议', 'ROI测算'],
    target: '年营收5亿元以上、拥有复杂渠道网络、正在规划营销数字化转型的快消品牌',
  },
  {
    id: 'operation',
    tag: '服务二',
    title: '营销数字化运营陪跑',
    subtitle: '营销策略研究、营销数字化运营体系建设',
    description: '不只是完成项目交付，更注重将管理经验与交付方法论沉淀为可复用知识资产。上线后持续支持，确保系统真正用起来、用出效果。',
    items: ['营销策略研究', '营销数字化运营体系建设', '运营方法论沉淀', '持续效果追踪'],
    target: '已上线营销数字化系统但运营效果未达预期，或缺乏专业运营团队的快消品牌',
  },
  {
    id: 'platform',
    tag: '服务三',
    title: '五位一体营销数字化平台搭建',
    subtitle: '加速企业营销数字化转型',
    description: '基于物码的"五位一体"营销数字化整体解决方案，打通经销商（F）、终端商户（B）、动销商户（b）、消费者（C）以及业务员/促销员五个核心角色，实现从"压货分销"向"动销驱动"转型。',
    modules: [
      {
        name: '一物一码数字底座',
        desc: '五码关联技术',
        detail: '通过"一物一码、五码关联"技术，覆盖产品生产、仓储、物流、渠道直至消费者的全生命周期，保障流向可追溯。',
      },
      {
        name: '全链路数据闭环',
        desc: '从压货分销到动销驱动',
        detail: '实现从"压货分销"向"动销驱动"转型，构建连接品牌、渠道与消费者的完整数字化营销闭环。',
      },
    ],
    tpcp: {
      tp: ['门店注册 / 业务员推广激励', '终端陈列达标奖励'],
      cp: ['NFC扫码赢红包 / 积分兑换', '限定款抽奖 / 节日主题活动'],
    },
  },
  {
    id: 'saas',
    tag: '服务四',
    title: 'bC一体化SaaS系统',
    subtitle: '包含生码系统、消费者互动营销平台、终端商户会员系统、经销商管理系统',
    description: '融慧数科自主研发，集渠道管理、终端数字化、消费者互动于一体，支持快速部署与定制扩展。',
    features: [
      { icon: 'ri-folders-line', title: '渠道费用管理', desc: '预算→审批→核销→复盘，全流程线上，费用透明可控' },
      { icon: 'ri-smartphone-line', title: '促销员数字工具', desc: '移动端全覆盖，执行数据实时上报' },
      { icon: 'ri-qr-scan-line', title: '消费者扫码互动', desc: '多场景激励设计，构建品牌与消费者直接连接' },
      { icon: 'ri-dashboard-3-line', title: '数据可视化看板', desc: '区域/门店/活动/人员四层穿透分析' },
    ],
  },
  {
    id: 'data',
    tag: '服务五',
    title: '大数据运营服务',
    subtitle: '沉淀用户数据，实现精细化运营',
    description: '将系统沉淀的终端数据转化为可执行的营销洞察，持续优化营销策略与资源配置。',
    items: ['终端动销监测', '消费者行为画像', '活动效果评估', '定期洞察报告'],
  },
];